import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";
import { map } from "rxjs/operators";
import { UserForm } from "app/interfaces/user-form.interface";

const videoFootageUrlApi = environment.videoFootageUrlApi;

const videoFootagesByIncidentUrlApi = environment.videoFootagesByIncidentUrlApi;
const videoOwnFootagesByIncidentUrlApi =
  environment.videoOwnFootagesByIncidentUrlApi;

const videoFootagesgetPosterFootageUrlApi =
  environment.videoFootagesgetPosterFootageUrlApi;

const gpsOneFootageUrlApi = environment.gpsOneFootageUrlApi;

const videoFootagesByUserUrlApi = environment.videoFootagesByUserUrlApi;
const videoFootagesByVideoUrlApi = environment.videoFootagesByVideoUrlApi;
const videoFootagesByIncidentandUserUrlApi =
  environment.videoFootagesByIncidentandUserUrlApi;

const gpsFake = environment.gpsFake;

@Injectable()
export class VideoFootageService {
  public user: UserForm;

  constructor(private http: HttpClient) {}

  getVideoFootagesByIncident(id: number) {
    return this.http
      .request("GET", `${videoFootagesByIncidentUrlApi}/` + id, {
        responseType: "json",
      })
      .pipe(map((resp: any) => resp));
  }

  getOwnVideoFootagesByIncident(id: number) {
    return this.http
      .request("GET", `${videoOwnFootagesByIncidentUrlApi}/` + id, {
        responseType: "json",
      })
      .pipe(map((resp: any) => resp));
  }

  getPosterOfVideoFootageById(id: number) {
    return this.http
      .request("GET", `${videoFootagesgetPosterFootageUrlApi}/` + id, {
        responseType: "json",
      })
      .pipe(map((resp: any) => resp));
  }

  createVideoFootage(idIncident, idUser, idVideo, videoFootageModel) {
    videoFootageModel.id_user = idUser;
    videoFootageModel.id_video = idVideo;
    videoFootageModel.id_incident = idIncident;
    console.log(videoFootageModel);
    const body = videoFootageModel;
    return this.http
      .request("POST", `${videoFootageUrlApi}`, {
        body,
      })
      .pipe(map((resp: any) => resp));
  }

  deleteVideoFootageById(id: number) {
    return this.http
      .request("DELETE", `${videoFootageUrlApi}/` + id, {
        responseType: "json",
      })
      .pipe(map((resp: any) => resp));
  }

  getGpsCoordenadesByVideoFootage(id: number) {
    return this.http
      .request("GET", `${gpsOneFootageUrlApi}/` + id, {
        responseType: "json",
      })
      .pipe(map((resp: any) => resp));
  }

  getGpsFake(id: number) {
    return this.http
      .request("GET", `${gpsFake}/` + id, {
        responseType: "json",
      })
      .pipe(map((resp: any) => resp));
  }

  /* 

  getVideoFootagesByUser(id: number) {
    return this.http
      .request("GET", `${videoFootagesByUserUrlApi}/` + id, {
        responseType: "json",
      })
      .pipe(map((resp: any) => resp));
  }

  getVideoFootagesByVideo(id: number) {
    return this.http
      .request("GET", `${videoFootagesByVideoUrlApi}/` + id, {
        responseType: "json",
      })
      .pipe(map((resp: any) => resp));
  }

  

  getVideoFootagesByUserAndIncident(id: number) {
    const body = {
      id_videoFootage: idVideoFootage,
      id_user: idUser,
      bookmark: true, 
    };
    return this.http
      .request("POST", `${videoFootagesByIncidentandUserUrlApi}`, { body })
      .pipe(map((resp: any) => resp));
  }


 */

  /* checkVideoFootageById(id: number) {
    return this.http
      .request("GET", `${videoFootagesCheckVideoFootageUrlApi}/` + id, {
        responseType: "json",
      })
      .pipe(map((resp: any) => resp));
  } */

  /* checkBookmark(idVideoFootage, idUser) {
    const body = {
      id_videoFootage: idVideoFootage,
      id_user: idUser,
      bookmark: true,
    };
    return this.http
      .request("POST", `${videoFootagesBookmarksCheckUnCheckListUrlApi}`, { body })
      .pipe(map((resp: any) => resp));
  }

  unCheckBookmark(idVideoFootage, idUser) {
    const body = {
      id_videoFootage: idVideoFootage,
      id_user: idUser,
      bookmark: false,
    };
    return this.http
      .request("POST", `${videoFootagesBookmarksCheckUnCheckListUrlApi}`, { body })
      .pipe(map((resp: any) => resp));
  } 

  getVideoFootageBookmarks() {
    return this.http
      .request("GET", `${videoFootagesBookmarksListUrlApi}`, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }

  */
  /*  updateVideoFootageById(id: number, videoFootageModel: VideoFootageForm) {
    console.log(id);
    console.log(videoFootageModel);
    const body = videoFootageModel;
    return this.http
      .request("PUT", `${videoFootagesUrlApi}/` + id, { body })
      .pipe(map((resp: any) => resp));
  } */
}
